// extracted by mini-css-extract-plugin
export default {"swatch":"watermark_swatch__aEcgR","popover":"watermark_popover__BSqqM","cover":"watermark_cover__DQFtP","disabledColor":"watermark_disabledColor__aG2rt"};